import { get, post, put, deleted } from '..';
import routes from './routes';

const SupplierServices = {
  createSupplier: async (obj) => {
    const data = await post(routes.createSupplier, obj);
    return data;
  },
  getSuppliers: async (params) => {
    const data = await get(routes.getSuppliers, params);
    return data;
  },
  getSupplierById: async (id) => {
    const data = await get(routes.getSupplierById + id);
    return data;
  },
  updateSupplier: async (id, obj) => {
    const data = await put(routes.updateSupplier + id, obj);
    return data;
  },
  deleteSupplier: async (id) => {
    const data = await deleted(routes.deleteSupplier + id);
    return data;
  },
}

export default SupplierServices